import axios from 'axios';

export const getContent = async (last) => {
    if (last === null) {
        const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/contents`);
        return data;
    } else {
        const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/contents/?content_object_id=${last}`);
        return data
    }
}